export const API_PATH_ApiAlertMgtmAlertHandlingPost = '/services/alerts-mgtm/apiAlertMgtmAlertHandlingPost';
